import { createFileRoute } from "@tanstack/react-router";
import { UploadIcon } from "lucide-react";

export const Route = createFileRoute("/admin/directories/$directoryId/files")({
  component: DirectoryFiles,
});

function DirectoryFiles() {
  const { directoryId } = Route.useParams();
  return (
    <div>
      <div className="label-card">Directory files</div>
      <div className="mt-1 flex items-end justify-between">
        <h1 className="font-display text-3xl font-semibold">
          Files in <span className="font-mono text-lg">{directoryId}</span>
        </h1>
        <button className="inline-flex items-center gap-2 rounded-md bg-paprika px-3 py-2 text-xs font-semibold uppercase tracking-widest text-white">
          <UploadIcon className="h-3.5 w-3.5" /> Upload
        </button>
      </div>
      <div className="mt-8 card-ledger p-8 text-center text-ink-soft">
        Drag-and-drop uploader + file list mounts here. Uses R2 presigned URLs
        from the Worker (see backend.md §11).
      </div>
    </div>
  );
}
